<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-3">
      <v-layout wrap>
        <v-flex xs12 v-if="request && request.id">
          <router-link
            :to="{ name: 'HelpDeskRequests' }"
            class="font-weight-bold text--primary"
            style="text-decoration: none;"
          >
            <span style="color:green"> All Support Requests</span>
          </router-link>

          <span>/{{ request.subject }}</span>
        </v-flex>

        <v-flex xs12 class="pb-2">
          <v-card
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
          >
            <div v-if="loading" class="px-3 mt-2 py-2">
              <v-progress-linear
                :indeterminate="true"
                color="success"
              ></v-progress-linear>
            </div>
            <v-layout row justify-space-between>
              <v-layout column class="ma-1 px-3">
                <v-card-text
                  class="mb-0 pb-0 pt-2 pl-2"
                  v-if="request && request.id"
                >
                  <div class="ml-0 my-2 body-1 font-weight-light">
                    Requested By:
                    <span class="font-weight-medium">{{
                      request.requesterName
                    }}</span>
                    On:
                    <span class="font-weight-medium">{{
                      request.createdAt | time
                    }}</span>
                    User:
                    <span class="font-weight-medium">{{ meUsername }}</span>
                    <span v-show="request.requesterEmailID">
                      Email:
                    </span>

                    <span class="font-weight-medium">{{
                      request.requesterEmail
                    }}</span>
                    Site:
                    <span class="font-weight-medium">{{
                      request.requestSiteName
                    }}</span>
                    Create via:
                    <span class="font-weight-medium">{{ request.source }}</span>
                  </div>
                  <v-layout row align-center>
                    <v-flex xs9>
                      <div class="mt-0 ml-3 my-2 body-1 font-weight-light">
                        <v-layout row class="mb-2">
                          <div class="font-weight-medium mr-2">
                            Technician:
                          </div>
                          <div>
                            {{ getTechnician() }}
                          </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                          <div class="font-weight-medium mr-2">
                            Category:
                          </div>
                          <div>
                            {{ request.categoryName }}
                          </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                          <div class="font-weight-medium mr-2">
                            Priority:
                          </div>

                          <div>
                            <v-icon
                              id="PriorityColor"
                              small
                              :color="getPriorityColor()"
                              >mdi-box-shadow</v-icon
                            >
                            {{ getPriority() }}
                          </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                          <div class="font-weight-medium mr-2">
                            ETA:
                          </div>

                          <div>
                            {{ getETA() }}
                          </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                          <div class="font-weight-medium mr-2">
                            Ticket Number:
                          </div>
                          <div v-if="isTechnician()">
                            <a
                              style="color: green;"
                              :href="
                                `https://utaw.sdpondemand.manageengine.com/app/itdesk/ui/requests/${
                                  request.manageengineID
                                }/details`
                              "
                              target="_blank"
                              >{{ "#" + request.displayID
                              }}<v-icon small color="green"
                                >mdi-open-in-new</v-icon
                              ></a
                            >
                          </div>
                          <div v-else>
                            {{ "#" + request.displayID }}
                          </div>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex>
                      <v-layout>
                        <v-icon
                          dark
                          style="font-size: 50px;"
                          :color="getStatusIconColor()"
                          >{{ getStatusIcon() }}</v-icon
                        >
                        <div class="title pt-3">
                          {{ request.statusName }}
                        </div>
                      </v-layout>
                      <div class="mt-2 ml-0 pr-0">
                        {{ getClosedInfo() }}
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-card
                    class="mb-3"
                    style="border: 0px solid rgb(255, 255, 255);  padding-top: 40px;"
                  >
                    <div
                      class="card-header"
                      style="background: rgb(202, 203, 232); display: flex ;"
                    >
                      <div
                        class="ml-3 font-weight-bold pt-1 pb-1"
                        style="font-size: 20px;"
                      >
                        {{ request.subject }}
                      </div>
                      <div style="margin-left: auto; margin-right: 20px;"></div>
                    </div>
                    <v-layout
                      row
                      justify-end
                      class="mb-2 mt-4 mr-2"
                      v-if="
                        request.description ||
                          JSON.parse(this.request.attachments).length > 0
                      "
                    >
                      <v-flex xs11>
                        <v-card
                          style="border: 2px solid rgb(243, 241, 249);  padding-top: 40px;"
                        >
                          <div
                            class="card-header"
                            style="background: rgb(243, 241, 249);"
                          >
                            <div class="ml-3">
                              {{ request.requesterName }}
                              -
                              {{ request.createdTimeDisplayValue }}
                            </div>
                          </div>

                          <div
                            class="ml-3 pl-3 mr-3 pr-3 mt-4 my-3 "
                            v-html="request.description"
                          ></div>
                          <v-divider class="mt-3"></v-divider>
                          <div
                            class="subheading font-weight-light ml-3 mt-3 mb-1"
                          >
                            {{ getAttachmentText() }}
                          </div>
                          <div class="attachments-container">
                            <div
                              v-for="attachment in getAttachments()"
                              :key="attachment.name"
                              class="ml-3"
                            >
                              <v-btn
                                v-if="!isAudioFile(attachment.name)"
                                class="mt-2 ml-1 px-3 button-attachment"
                                @click="loadFile(attachment)"
                              >
                                <v-icon color="blue" left dark>mdi-file</v-icon>
                                {{ truncateText(attachment.name) }}
                                <v-icon right>mdi-open-in-new</v-icon>
                              </v-btn>

                              <audio v-else controls class="mt-2 ml-1">
                                <source
                                  :src="getAudioSrc(attachment)"
                                  type="audio/mpeg"
                                />
                              </audio>
                            </div>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-show="!request.description"
                      class="mt-3 mb-3"
                    ></v-layout>

                    <v-layout
                      row
                      justify-end
                      class="mr-2"
                      v-if="shouldShowConversationBtn"
                    >
                      <v-flex xs11>
                        <v-card
                          style="border: 3px solid rgb(211, 219, 218);  padding-top: 33px;"
                        >
                          <button
                            class="card-header"
                            style="background: rgb(211, 219, 218); text-align: left;"
                            :disabled="loadingConversations"
                            @click="clickConversationBtn()"
                          >
                            <div
                              v-show="
                                !loadingConversations && showConversationBtn
                              "
                              style="text-align: center;"
                            >
                              Click here to Show all conversations
                            </div>
                            <div
                              v-show="loadingConversations"
                              style="text-align: center;"
                            >
                              loading conversations...
                            </div>
                            <div
                              v-show="loadAllConversationsBtn"
                              style="text-align: center;"
                            >
                              Click on conversation or click here to expand all
                              conversations
                            </div>
                          </button>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      justify-end
                      class="mr-2"
                      v-for="(conversation, index) in conversationList"
                    >
                      <v-flex xs11>
                        <v-card
                          :style="
                            `border: 3px solid rgb(${
                              conversation.type === 'CONVERSATION'
                                ? '255, 229, 229'
                                : '217, 255, 235'
                            }); bposition: relative; padding-top: 33px;`
                          "
                        >
                          <button
                            class="card-header"
                            :disabled="conversation.load"
                            :style="
                              `background: rgb(${
                                conversation.type === 'CONVERSATION'
                                  ? '255, 229, 229'
                                  : '217, 255, 235'
                              }); text-align: left;`
                            "
                            @click="expandConversation(index)"
                          >
                            <div
                              class="ml-3"
                              style="display: flex; align-items: center; width: 100%;"
                            >
                              <div>
                                {{
                                  conversation.senderName != "UserPortal"
                                    ? conversation.senderName + " - "
                                    : ""
                                }}

                                {{ conversation.timeDisplayValue }}
                                <span v-if="conversation.hasAttachments">
                                  -
                                  <v-icon>mdi-attachment</v-icon>
                                </span>
                              </div>
                              <span
                                style="margin-left: auto; margin-right: 50%;"
                                v-show="
                                  !conversation.expanded && !conversation.load
                                "
                              >
                                <v-icon small>mdi-arrow-expand</v-icon>
                              </span>
                              <span
                                style="margin-left: auto; margin-right: 50%;"
                                v-show="conversation.load"
                              >
                                load...
                              </span>
                            </div>
                          </button>

                          <div
                            v-show="conversation.expanded"
                            class="ml-0 mt-4 pl-3 my-3"
                          >
                            <h6
                              class="font-weight-bold"
                              v-html="conversation.subject"
                            ></h6>
                            <p class="mt-2" v-if="conversation.sendTo">
                              <b>To:</b>
                              {{ getSendCTo(conversation.sendTo) }}
                            </p>
                            <v-divider class="mt-3 mb-3"></v-divider>
                            <p v-html="conversation.description"></p>
                            <v-divider
                              v-if="conversation.attachments"
                              class="mt-3"
                            ></v-divider>
                            <div
                              v-if="conversation.attachments"
                              class="subheading font-weight-light ml-3 mt-3 mb-1"
                            >
                              {{
                                getConversationAttachmentCount(
                                  conversation.attachments
                                )
                              }}
                            </div>
                            <div
                              class="attachments-container"
                              v-if="conversation.attachments"
                            >
                              <div
                                v-for="attachment in getConversationAttachments(
                                  conversation.attachments
                                )"
                                :key="attachment.name"
                                class="ml-3"
                              >
                                <v-btn
                                  v-if="!isAudioFile(attachment.name)"
                                  class="mt-2 ml-1 px-3 button-attachment"
                                  @click="loadFile(attachment)"
                                >
                                  <v-icon color="blue" left dark
                                    >mdi-file</v-icon
                                  >
                                  {{ truncateText(attachment.name) }}
                                  <v-icon right>mdi-open-in-new</v-icon>
                                </v-btn>

                                <audio v-else controls class="mt-2 ml-1">
                                  <source
                                    :src="getAudioSrc(attachment)"
                                    type="audio/mpeg"
                                  />
                                </audio>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-layout>
            </v-layout>
            <v-spacer></v-spacer>
            <div v-if="request && request.id">
              <v-flex
                style="display: flex; align-items: center; justify-content: center; width: 100%;"
              >
                <v-btn
                  class="mr-3 mb-2"
                  style="color: red;"
                  @click="closeTicketDialog = true"
                  :disabled="request.statusName == 'Closed'"
                >
                  Close ticket
                </v-btn>
                <v-btn
                  style="color: green;"
                  class="mr-3 mb-2"
                  v-if="request.statusName != 'Closed'"
                  @click="
                    oldTicket
                      ? (addConversation.oldTicketDialog = true)
                      : (addConversation.dialog = true)
                  "
                >
                  Add Comment
                </v-btn>

                <v-tooltip top v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      style="color: green;"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3 mb-2"
                      @click="
                        oldTicket
                          ? (addConversation.oldTicketDialog = true)
                          : (addConversation.dialog = true)
                      "
                    >
                      Add Comment
                    </v-btn>
                  </template>
                  <span> Adding a comment will reopen the ticket.</span>
                </v-tooltip>
              </v-flex>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="addConversation.dialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Add Comment</span>
          <span class="ml-3" style="color: red;"
            >If this is a different topic
            <router-link
              :to="{
                name: 'HelpDeskRequests',
                query: {
                  openNewTicket: true,
                },
              }"
            >
              <span style="color:green">
                click here to open a separate ticket.</span
              >
            </router-link></span
          >
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-Textarea
                  v-model="addConversation.description"
                  label="Write a message"
                  outline
                  ref="addConversation"
                ></v-Textarea>
              </v-flex>
              <!-- <v-flex xs18 sm8> <v-btn small class="ml-0 mt-0" color="success" :loading="addConversation.uploading" @click="pickFile()" >Upload Files <v-icon right small >mdi-cloud-upload</v-icon ></v-btn > </v-flex> <v-card v-for="(file, index) in addConversation.fileUploadList" style="border: 1px solid #4caf50; border-radius: 5px; margin-right: 10px;" class="pa-2 my-2" > <v-layout row justify-space-between style="width: 250px;"> <div class="mt-0 ml-0 pt-1"> {{ truncateText(file.name, 18) }} </div> <v-btn color="success" class="my-0 mr-1" small @click="removeUploadImg(index)" > remove </v-btn> </v-layout> </v-card>-->
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn
              color="default"
              @click="resetConversationForm"
              :dark="!addConversation.cancelBtnAbility"
              :disabled="addConversation.cancelBtnAbility"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="sendNewConversation"
              :dark="addConversation.cancelBtnAbility"
              :disabled="!addConversation.description"
              >Send</v-btn
            >
            <!-- <input type="file" multiple style="display: none" ref="files" @change="onFilePicked($event)" /> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addConversation.oldTicketDialog"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title>
          <v-layout column>
            <div class="headline mb-2">Attention!</div>

            <div class="mb-2 ml-3">
              This ticket has been closed for a long time.
            </div>

            <router-link
              :to="{
                name: 'HelpDeskRequests',
                query: { openNewTicket: true },
              }"
            >
              <div class="green--text ml-3 font-weight-medium">
                Click here to open a new ticket.
              </div>
            </router-link>
          </v-layout>
        </v-card-title>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="addConversation.oldTicketDialog = false"
            dark
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <close-ticket-dialog
      v-if="request && request.id"
      v-model="closeTicketDialog"
      :initial-data="{ request: request }"
      @tickedClosed="loadRequest()"
    />
  </div>
</template>
<script>
import {
  formatPhoneNumber,
  truncate,
  pluralize,
  getDomain,
} from "../../utils/helpers.js";
import CloseTicketDialog from "./CloseTicketDialog.vue";
import { getETA } from "./helpDeskHelpers.js";
export default {
  components: {
    CloseTicketDialog,
  },
  data: () => ({
    request: null,
    showConversationBtn: false,
    loadingConversations: false,
    loadAllConversationsBtn: false,
    conversationList: null,
    conversationAttachments: null,
    processing: false,
    loading: true,

    closeTicketDialog: false,

    oldTicket: false,
    meUsername: null,

    addConversation: {
      dialog: false,
      displayID: null,
      ManageengineID: null,
      Subject: null,
      description: null,
      uploading: false,
      fileUploadList: [],
      cancelBtnAbility: false,
      sendBtnDisability: false,
      oldTicketDialog: false,
    },
    regID: "",
  }),
  computed: {
    shouldShowConversationBtn() {
      return (
        (Date.now() - 2.678e9 <
          new Date(this.request.lastUpdatedTime).getTime() ||
          this.request.statusName !== "Closed") &&
        (this.loadAllConversationsBtn || this.showConversationBtn)
      );
    },
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      await this.loadRequest();
    },
    async loadRequest() {
      try {
        const response = await this.$http.get(
          `api/manageengine/getRequestbyID?id=${this.$route.params.id}`
        );

        if (response.notFound) {
          this.$notify({
            text:
              "Ticket not found – it was probably deleted or merged with another request.",
            group: "notification",
            type: "error",
          });
          setTimeout(() => {
            this.$router.push("/helpdesk/requests");
          }, "500");
          return;
        }
        this.request = response.request;
        this.meUsername = response.username;
        this.loading = false;
        if (
          this.request.statusName == "Closed" &&
          Date.now() - 2.678e9 >
            new Date(response.request.lastUpdatedTime).getTime()
        ) {
          this.oldTicket = true;
        }
        if (response.request.notificationStatus != null) {
          this.showConversationBtn = true;
        }
      } catch (e) {
        setTimeout(() => {
          this.$router.push("/helpdesk/requests");
        }, "500");
      }
    },

    // isAdmin() {
    //   const isAdmin = this.$store.getters["authentication/isAdmin"];
    //   if (!isAdmin || isAdmin == "false") return false;

    //   return true;
    // },

    isTechnician() {
      const roles = this.$store.getters["authentication/getRoles"];
      const isTech = roles.includes("Technician");
      return isTech;
    },

    formatPhoneNumber(number) {
      return formatPhoneNumber(number);
    },
    getStatusIcon() {
      if (!this.request || !this.request.statusName) return;

      switch (this.request.statusName) {
        case "Closed":
          return "mdi-check-circle";
        case "Open":
        case "Reopened":
          return "mdi-clock";
        case "On Hold":
          return "mdi-clock";
        case "Canceled":
          return "mdi-cancel";
        default:
          return "";
      }
    },
    getStatusIconColor() {
      if (!this.request || !this.request.statusName) return;

      switch (this.request.statusName) {
        case "Closed":
          return "#2ecc71";
        case "Open":
        case "Reopened":
          return "#f1c40f";
        case "On Hold":
          return "#3498db";
        case "Canceled":
          return "#e74c3c";
        default:
          return "#bdc3c7";
      }
    },
    getClosedInfo() {
      if (!this.request.lastUpdatedTime) {
        return;
      }
      if (this.request.statusName != "Closed") {
        let lastUpdatedTime = new Date(this.request.lastUpdatedTime);
        return `Ticket was last updated on ${lastUpdatedTime.toLocaleDateString()} at ${lastUpdatedTime.toLocaleTimeString()} `;
      }
      let completedTime = new Date(this.request.completedTime);
      return `Ticket closed on ${completedTime.toLocaleDateString()} at ${completedTime.toLocaleTimeString()}`;
    },
    getAttachmentText() {
      const getAttachments = this.getAttachments();
      if (!getAttachments || getAttachments.length == 0) {
        return;
      }
      return (
        getAttachments.length +
        " " +
        pluralize("Attachment", getAttachments.length)
      );
    },
    getAttachments() {
      if (!this.request || !this.request.attachments) return [];
      return JSON.parse(this.request.attachments);
    },

    getTechnician() {
      if (
        !this.request ||
        !this.request.technicianID ||
        this.request.technicianName == "UserPortal"
      )
        return "This ticket has not yet been assigned";

      return this.request.technicianName;
    },
    // downloadAttachment(attachment) {
    //     window.location = attachment;
    // },
    truncateText(attachment) {
      return truncate(attachment, 30);
    },
    async loadFile(file) {
      const url =
        getDomain() +
        `/api/manageengine/GetAttachments?url=${encodeURIComponent(
          file.content_url
        )}`;
      const response = await fetch(url, {
        headers: {
          authorization: `${$cookies.get("user-token")}`,
        },
      });
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl, "_blank");
    },
    isAudioFile(fileName) {
      const audioExtensions = [".mp3", ".wav", ".ogg", ".m4a"];
      return audioExtensions.some((ext) =>
        fileName.toLowerCase().endsWith(ext)
      );
    },

    getAudioSrc(file) {
      return `${getDomain()}/api/manageengine/GetAttachments?url=${
        file.content_url
      }&name=${file.name}`;
    },
    getPriority() {
      const priorityMap = {
        "1 High": "High",
        "3 Option 8": "High",
        "2 Normal": "Normal",
        "4 Low": "Low",
      };
      return priorityMap[this.request.priorityName];
    },
    getETA() {
      return getETA(this.request);
    },
    getPriorityColor() {
      const priorityMap = {
        "1 High": "#e74c3c",
        "3 Option 8": "#e74c3c",
        "2 Normal": "#f39c12",
        "4 Low": "#7f8c8d",
      };
      return priorityMap[this.request.priorityName];
    },
    clickConversationBtn() {
      if (!this.loadAllConversationsBtn) {
        this.getConversations();
      } else {
        this.expandAllConversations();
      }
    },
    async getConversations() {
      this.loadingConversations = true;
      this.loading = true;
      const conversations = await this.$http.get(
        `api/manageengine/GetConversationsByTicket?manageengineID=${
          this.request.manageengineID
        }&requestID=${this.request.id}`
      );
      this.loading = false;
      this.loadingConversations = false;
      this.showConversationBtn = false;
      this.loadAllConversationsBtn = true;
      this.conversationList = conversations.map((c) => ({
        ...c,
        expanded: false,
        load: false,
      }));
    },
    async expandConversation(i) {
      if (this.conversationList[i].expanded) {
        this.conversationList[i].expanded = false;
        this.$set(this.conversationList, i, this.conversationList[i]);
        return;
      }
      this.conversationList[i].load = true;
      try {
        const response = await this.$http.get(
          `api/manageengine/GetConversation?manageengineID=${
            this.conversationList[i].manageengineRequestID
          }&conversationID=${this.conversationList[i].conversationID}`
        );
        this.conversationList[i].load = false;
        this.$set(this.conversationList, i, response);
      } catch {}

      this.conversationList[i].expanded = true;
    },

    async expandAllConversations() {
      this.conversationList.map((c) => (c.load = true));
      this.loadAllConversationsBtn = false;
      for (var i = 0; i < this.conversationList.length; i++) {
        try {
          const response = await this.$http.get(
            `api/manageengine/GetConversation?manageengineID=${
              this.conversationList[i].manageengineRequestID
            }&conversationID=${this.conversationList[i].conversationID}`
          );
          this.conversationList[i].load = false;
          this.$set(this.conversationList, i, response);
          this.conversationList[i].expanded = true;
        } catch {}
      }
    },

    getConversationAttachments(attachments) {
      return JSON.parse(attachments);
    },
    getConversationAttachmentCount(attachments) {
      return (
        JSON.parse(attachments).length +
        " " +
        pluralize("Attachment", JSON.parse(attachments).length)
      );
    },
    getSendCTo(l) {
      return JSON.parse(l).join(", ");
    },
    async sendNewConversation() {
      try {
        this.processing = true;
        this.addConversation.cancelBtnAbility = true;
        const desc = `${this.addConversation.description.trim()}`;
        const description = desc
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");
        const info = `<b>From: </b> ${
          this.$store.state.authentication.user
        } <br><br><br>`;
        const response = await this.$http.post(
          "api/Manageengine/AddConversation",
          {
            DisplayID: this.request.displayID,
            ManageengineID: this.request.manageengineID,
            Subject: this.request.subject,
            Description: info + description,
            technicianName: this.request.technicianName,
          }
        );
        this.$notify({
          text: "sent successfully",
          group: "notification",
          type: "success",
        });
        await this.loadRequest();
        this.resetConversationForm();
        await this.getConversations();
        await this.expandConversation(this.conversationList.length - 1);
        this.addConversation.cancelBtnAbility = false;
        this.processing = false;
      } catch (err) {
        this.$notify({
          text: "massege not send",
          group: "notification",
          type: "error",
        });
        this.resetConversationForm();
      }
    },
    resetConversationForm() {
      this.addConversation.dialog = false;
      this.addConversation.description = null;
      // this.removeAllUploadImg();
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.addConversation.uploading = true;
      this.addConversation.sendBtnDisability = true;
      const files = e.target.files;

      if (!files) return;
      try {
        for (var i = 0; i < files.length; i++) {
          var formData = new FormData();
          formData.append("file", files[i]);
          const response = await this.$http.post(
            "api/Manageengine/ManageengineUpload",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          this.fileUploadList.push(response.files[0]);
        }
        this.addConversation.uploading = false;
        this.addConversation.sendBtnDisability = false;
        this.$refs.files.value = null;
      } catch (e) {
        this.addConversation.uploading = false;
      }
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}

.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}

.tip-grid.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}

.tip-grid .v-card__text {
  padding-top: 4px !important;
}

.tip-grid .flex {
  padding: 0px !important;
  padding-top: 24px !important;
}

.tip-grid .v-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}

.card-header {
  padding: 5px 0;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.ticket-card {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.button-attachment {
  max-width: 100%;
  display: block;
  margin-top: 8px;
  text-overflow: ellipsis;
}

.ticket-card audio {
  max-width: 100%;
  display: block;
  margin-top: 8px;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
</style>
